import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Morphs a PDP block from the server-rendered section HTML after variant change.
 *
 * @param {Element} element
 * @param {Document} html
 * @param {string} tagName
 */
const morphFromSectionHtml = (element, html, tagName) => {
  const blockId = element.dataset.blockId;
  const productId = element.dataset.productId;
  if (!blockId) return;

  const selector = `${tagName}[data-block-id="${blockId}"]`;
  const next = productId
    ? html.querySelector(`${selector}[data-product-id="${productId}"]`) ?? html.querySelector(selector)
    : html.querySelector(selector);

  if (!next) {
    element.innerHTML = '';
    return;
  }

  morph(element, next, { childrenOnly: true });
};

/**
 * @param {string} tagName
 * @returns {new () => Component & HTMLElement}
 */
const createVariantSyncElement = (tagName) =>
  class SimucubeVariantSync extends Component {
    /** @type {AbortController} */
    #abortController = new AbortController();

    connectedCallback() {
      super.connectedCallback();

      const section = this.closest('.shopify-section');
      section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
        signal: this.#abortController.signal,
      });
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.#abortController.abort();
    }

    /** @param {import('@shopify/events').ProductSelectEvent} event */
    #handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html) return;
          if (detail.productId && detail.productId !== this.dataset.productId) return;

          morphFromSectionHtml(this, detail.html, tagName);
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') {
            console.warn(`[${tagName}] Event promise rejected:`, error);
          }
        });
    };
  };

if (!customElements.get('simucube-inventory-badge')) {
  customElements.define('simucube-inventory-badge', createVariantSyncElement('simucube-inventory-badge'));
}

if (!customElements.get('simucube-backorder-notice')) {
  customElements.define('simucube-backorder-notice', createVariantSyncElement('simucube-backorder-notice'));
}

if (!customElements.get('simucube-stock-indicator')) {
  customElements.define('simucube-stock-indicator', createVariantSyncElement('simucube-stock-indicator'));
}
